import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import NotFoundPage from './pages/NotFoundPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import CartPage from './pages/CartPage';
import NewsPage from './pages/NewsPage';
import WishlistPage from './pages/WishlistPage';
import OrdersPage from './pages/OrdersPage';
import AccountPage from './pages/AccountPage';
import ReportPage from './pages/ReportPage';
import OtherPage from './pages/OtherPage';
import SearchResultsPage from './pages/SearchResultsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import FaqPage from './pages/FaqPage';
import SitePolicyPage from './pages/SitePolicyPage';
import MessagesPage from './pages/MessagesPage';
import TopupPage from './pages/TopupPage';
import CryptoCheckoutPage from './pages/CryptoCheckoutPage';
import CreditCheckoutPage from './pages/CreditCheckoutPage';
import CustomCursor from './components/CustomCursor';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CustomCursor />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="product/:productId" element={<ProductPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="auth" element={<AuthPage />} />
            <Route path="login" element={<AuthPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="search" element={<SearchResultsPage />} />
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="cookies" element={<CookiesPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="policy" element={<SitePolicyPage />} />
            <Route path="dashboard" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />
            <Route path="cart" element={
              <ProtectedRoute>
                <CartPage />
              </ProtectedRoute>
            } />
            <Route path="wishlist" element={
              <ProtectedRoute>
                <WishlistPage />
              </ProtectedRoute>
            } />
            <Route path="orders" element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            } />
            <Route path="account" element={
              <ProtectedRoute>
                <AccountPage />
              </ProtectedRoute>
            } />
            <Route path="messages" element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            } />
            <Route path="report" element={
              <ProtectedRoute>
                <ReportPage />
              </ProtectedRoute>
            } />
            <Route path="topup" element={
              <ProtectedRoute>
                <TopupPage />
              </ProtectedRoute>
            } />
            <Route path="checkout/crypto" element={
              <ProtectedRoute>
                <CryptoCheckoutPage />
              </ProtectedRoute>
            } />
            <Route path="checkout/credits" element={
              <ProtectedRoute>
                <CreditCheckoutPage />
              </ProtectedRoute>
            } />
            <Route path="other" element={<OtherPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
